export function validateDate(value: string): boolean {
    return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export function validatePhone(value: string): boolean {
    return /^\(\d{3}\) \d{3}-\d{4}$/.test(value);
}

export function validateEmail(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
